import Navigo from 'navigo';
import { actions } from './';
import { actions as siteActions } from '../site';
import { actions as accountActions } from '../account';
import { actions as userActions, selectors as userSelectors } from '../user';
import { actions as videoServiceActions } from '../video-service';
export let router = new Navigo('/');

export const configureOpenRouter = (store) => {
    function baseRouteHandler(match) {
        const { route, data } = match;
        const { name } = route;
        store.dispatch(actions.setRoute({ name, data }));
    }

    function setSiteAuthHandler(match) {
        const { data, params, route } = match;
        const { authSite } = data;
        // note - this token is the password reset token
        const token = params?.token;
        if (token) {
            store.dispatch(accountActions.setPasswordResetToken({ token }));
        }
        // !_ is sort of a hack but _ is our "root actions" route, so we don't want to set that as an auth site
        if (authSite && authSite !== '_') {
            // todo double check doing this doesn't conflict with other route/security assumptions
            store.dispatch(userActions.setActiveAuthSite({ activeAuthSite: authSite }));
        }
        return baseRouteHandler(match);
    }
    // todo the non-authsite prefixed login and reset password links don't seem to work as expected (i.e. NOT set the authsite to 'login' or 'reset-password')
    // I think some of the forwarding logic may be messing them up
    // todo try to fix so a user could go to /login and not have that be interpreted as a site called login. May not be strictly necessary but
    // feels like something we should be able to do
    router.on({
        // '/:authSite': {
        //     as: 'home',
        //     uses: setSiteAuthHandler,
        // },
        '/:authSite/login': {
            as: 'login-site',
            uses: setSiteAuthHandler,
        },
        // '/login': {
        //     as: 'login',
        //     uses: baseRouteHandler,
        // },
        '/:authSite/reset-password': {
            as: 'reset-password-site',
            uses: setSiteAuthHandler,
        },
        '/:authSite/*': {
            as: 'general',
            uses: setSiteAuthHandler,
        },
        '/': {
            as: 'home',
            uses: baseRouteHandler,
        },
    });
    router.resolve();
};

export const configureRouter = (store) => {
    // seems like we need to re-instanciate the router here rather than just destroy, or else browerser nav doesn't work
    router.destroy();
    router = new Navigo('/');
    function baseRouteHandler(match) {
        const { route, data } = match;
        const { name } = route;
        store.dispatch(actions.setRoute({ name, data }));
    }

    function videoServiceRouteHandler(match) {
        const { data } = match;
        store.dispatch(videoServiceActions.unselectAllPackages());
        baseRouteHandler(match);
    }

    function videoServiceDetailsRouteHandler(match) {
        const { data } = match;
        const { packageId } = data;
        store.dispatch(videoServiceActions.selectPackage({ packageId }));
        baseRouteHandler(match);
    }

    function siteListRouteHandler(match) {
        store.dispatch(siteActions.unselectSite());
        store.dispatch(siteActions.unsetParentSite());
        appSiteSportRouteHandler(match);
    }

    function siteDetailsRouteHandler(match) {
        const { data } = match;
        const { site, sport } = data;
        // todo should this kind of stuff be in a hook or some other system?
        // todo could use before hook to load templates if not loaded
        store.dispatch(siteActions.selectSite({ name: site, sport }));
        appSiteSportRouteHandler(match);
    }

    function siteNewRouteHandler(match) {
        appSiteSportRouteHandler(match);
        store.dispatch(siteActions.newSite());
    }

    function childSiteListRouteHandler(match) {
        const { data } = match;
        const { parent, sport } = data;
        store.dispatch(siteActions.unselectSite());
        store.dispatch(siteActions.setParentSite({ parentSite: parent, sport }));
        appSiteSportRouteHandler(match);
    }

    function childSiteNewRouteHandler(match) {
        const { data } = match;
        const { parent, sport } = data;
        store.dispatch(siteActions.setParentSite({ parentSite: parent, sport }));
        siteNewRouteHandler(match);
    }

    function childSiteDetailsRouteHandler(match) {
        const { data } = match;
        const { parent, sport } = data;
        store.dispatch(siteActions.setParentSite({ parentSite: parent, sport }));
        siteDetailsRouteHandler(match);
    }

    // todo do we need a multiple select option here?
    function userAdminRouteHandler(match) {
        const { data, route } = match;
        if (!data?.authSite) {
            // if no site, then we see if we have one already and forward
            const activeAuthSite = userSelectors.activeAuthSiteNameSelector(store.getState());
            if (activeAuthSite) {
                return router.navigateByName('user-list', { authSite: activeAuthSite });
            }
            return baseRouteHandler(match);
        }
        const { authSite } = data;
        if (authSite) {
            store.dispatch(userActions.setActiveAuthSite({ activeAuthSite: authSite }));
            return baseRouteHandler(match);
        }
    }

    function userDetailsRouteHandler(match) {
        const { data } = match;
        const { eUserId } = data;
        const eSiteId = setupSiteByMatch(match);
        store.dispatch(userActions.userDetails({ eUserId, eSiteId }));
        baseRouteHandler(match);
    }

    function newUserRouteHandler(match) {
        const eSiteId = setupSiteByMatch(match);
        // all these newX actions require the templates to be loaded first
        // if we delayed this until the templates were loaded we could push the template loading out of app_main
        store.dispatch(userActions.newUser({ eSiteId }));
        baseRouteHandler(match);
    }

    function setupSiteByMatch(match) {
        const { data } = match;
        const { authSite } = data;
        const activeAuthSite = userSelectors.activeAuthSiteNameSelector(store.getState());
        // if we don't have this as an active auth site, try to set it.
        // todo review what happens if we lose access or don't have access to this authsite
        if (authSite !== activeAuthSite) {
            store.dispatch(userActions.setActiveAuthSite({ activeAuthSite: authSite }));
        }
        // need to get the siteId here too
        const eSiteId = userSelectors.activeAuthSiteIdSelector(store.getState());
        return eSiteId;
    }
    // todo do we need this now? trying without
    function appSiteSportRouteHandler(match) {
        const { data } = match;
        const { sport } = data;
        // todo should this kind of stuff be in a hook or some other system?
        // in ferp it would be handled in features
        store.dispatch(siteActions.setSport({ sport }));
        baseRouteHandler(match);
    }

    router.on({
        // '/overview': {
        //     as: 'overview',
        //     uses: baseRouteHandler,
        // },
        /*
        site management routes
        */
        '/_/:sport/sites': {
            as: 'site-list',
            uses: siteListRouteHandler,
        },

        '/_/:sport/sites/detail/:site': {
            as: 'site-detail',
            uses: siteDetailsRouteHandler,
        },
        '/_/:sport/sites/new': {
            as: 'site-new',
            uses: siteNewRouteHandler,
        },

        '/_/:sport/sites/:parent/childsites': {
            as: 'child-site-list',
            uses: childSiteListRouteHandler,
        },

        '/_/:sport/sites/:parent/childsites/detail/:site': {
            as: 'child-site-detail',
            uses: childSiteDetailsRouteHandler,
        },
        '/_/:sport/sites/:parent/childsites/new': {
            as: 'child-site-new',
            uses: childSiteNewRouteHandler,
        },
        /*
        video service routes
        */
        '/_/video-service': {
            as: 'video-service-list',
            uses: videoServiceRouteHandler,
        },
        '/_/video-service/detail/:packageId': {
            as: 'video-service-detail',
            uses: videoServiceDetailsRouteHandler,
        },
        /*
        user management routes
        note authSite is different than appSite (site above)
        */
        '/:authSite/users': {
            as: 'user-list',
            uses: userAdminRouteHandler,
        },
        '/:authSite/users/detail/:eUserId': {
            as: 'user-detail',
            uses: userDetailsRouteHandler,
        },
        '/:authSite/users/new': {
            as: 'user-new',
            uses: newUserRouteHandler,
        },
        '/_/auth-sites/list': {
            as: 'auth-site-list',
            uses: baseRouteHandler,
        },
        '/_/auth-sites/search-all': {
            as: 'user-search-all',
            uses: baseRouteHandler,
        },
        '/:authSite': {
            as: 'user-landing',
            uses: userAdminRouteHandler,
        },
        // '/': {
        //     as: 'logout',
        //     uses: baseRouteHandler,
        // },
    });
    router.resolve();
};
